import React from "react";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Typography,
  Box,
  Paper,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { PlannerLayout } from "../../layouts";

export const HelpPage = () => {
  const [expanded, setExpanded] = React.useState<string | false>(false);

  const handleChange =
    (panel: string) => (event: React.SyntheticEvent, isExpanded: boolean) => {
      setExpanded(isExpanded ? panel : false);
    };

  const faqQuestions = {
    Comenzando: [
      {
        question: "¿Cómo puedo crear un evento?",
        answer: "Aquí explicarías el proceso para crear un evento...",
        id: "comenzando-1",
      },
      {
        question: "¿Qué información necesito para configurar un evento?",
        answer: "Detalla qué información es necesaria...",
        id: "comenzando-2",
      },
      {
        question: "¿Hay límites en el número de eventos que puedo crear?",
        answer: "Información sobre cualquier límite...",
        id: "comenzando-3",
      },
    ],
    "Gestión de Eventos": [
      {
        question: "¿Cómo actualizo los detalles de un evento existente?",
        answer:
          "Para actualizar los detalles de un evento, debes ir a la sección 'Mis eventos', seleccionar el evento que deseas modificar y hacer clic en 'Editar'. Aquí podrás cambiar la información que necesites.",
        id: "gestion-1",
      },
      {
        question:
          "¿Cómo puedo promocionar mi evento a través de la plataforma?",
        answer:
          "Ofrecemos varias herramientas de promoción dentro de la plataforma, incluyendo opciones para destacar tu evento en nuestra página principal, enviar notificaciones por correo electrónico y compartir en redes sociales.",
        id: "gestion-2",
      },
      {
        question:
          "¿Qué herramientas están disponibles para analizar el rendimiento de mi evento?",
        answer:
          "Proporcionamos análisis detallados de ventas, asistencia y datos demográficos de los asistentes, que puedes consultar en tiempo real en el dashboard de tu evento.",
        id: "gestion-3",
      },
    ],
    "Venta de Entradas": [
      {
        question: "¿Cómo se maneja la venta de entradas y la recaudación?",
        answer: "Aca va el texto de respuesta.",
        id: "venta-1",
      },
      {
        question:
          "¿Qué opciones de tarifas y precios puedo establecer para mis entradas?",
        answer: "Aca va el texto de respuesta.",
        id: "venta-2",
      },
      {
        question: "¿Cómo puedo ofrecer descuentos o promociones?",
        answer: "Aca va el texto de respuesta.",
        id: "venta-3",
      },
    ],
    "Seguridad y Privacidad": [
      {
        question:
          "¿Qué medidas de seguridad utiliza la plataforma para proteger mi información y la de los asistentes?",
        answer: "Aca va el texto de respuesta.",
        id: "seguridad-1",
      },
      {
        question:
          "¿Cómo puedo acceder a los datos de los asistentes y cómo se protege su privacidad?",
        answer: "Aca va el texto de respuesta.",
        id: "seguridad-2",
      },
    ],
    "Pagos y Finanzas": [
      {
        question: "¿Cómo y cuándo recibo los pagos por la venta de entradas?",
        answer: "Aca va el texto de respuesta.",
        id: "finazas-1",
      },
      {
        question: "¿Qué tarifas cobra la plataforma y cómo se calculan?",
        answer: "Aca va el texto de respuesta.",
        id: "finazas-2",
      },
      {
        question:
          "¿Cómo puedo reembolsar las entradas si mi evento se cancela?",
        answer: "Aca va el texto de respuesta.",
        id: "finazas-3",
      },
    ],
    "Soporte y Contacto": [
      {
        question:
          "¿Cómo puedo contactar al soporte si tengo problemas o preguntas?",
        answer: "Aca va el texto de respuesta.",
        id: "soporte-1",
      },
      {
        question:
          "¿Hay recursos o tutoriales disponibles para aprender a usar la plataforma?",
        answer: "Aca va el texto de respuesta.",
        id: "soporte-2",
      },
      {
        question:
          "¿Cómo maneja la plataforma las disputas o los problemas con los asistentes?",
        answer: "Aca va el texto de respuesta.",
        id: "soporte-3",
      },
    ],
    "Personalización y Marca": [
      {
        question:
          "¿Puedo personalizar las páginas de mis eventos para que coincidan con la marca de mi empresa o evento?",
        answer: "Aca va el texto de respuesta.",
        id: "marca-1",
      },
      {
        question:
          "¿Qué opciones de marketing y publicidad ofrece la plataforma?",
        answer: "Aca va el texto de respuesta.",
        id: "marca-2",
      },
    ],
    "Funcionalidades y Herramientas Adicionales": [
      {
        question:
          "¿Hay integraciones disponibles con otras plataformas o herramientas de gestión de eventos?",
        answer: "Aca va el texto de respuesta.",
        id: "funconealidades-1",
      },
      {
        question:
          "¿Cómo puedo utilizar la analítica avanzada para mejorar mis eventos futuros?",
        answer: "Aca va el texto de respuesta.",
        id: "funconealidades-2",
      },
    ],
  };

  return (
    <PlannerLayout title="Centro de Ayuda">
      <Box sx={{ mb: 2 }}>
        <Typography
          fontSize={40}
         
          component="div"
          align="left"
        >
          Centro de ayuda
        </Typography>
      </Box>
      <Paper
        elevation={3}
        sx={{
          padding: 2,
          height: "600px", 
          overflowY: "auto", 
        }}
      >
        {Object.entries(faqQuestions).map(([category, questions], index) => (
          <Box key={index} sx={{ mb: 2 }}>
            <Typography variant="h5" sx={{ my: 2 }}>
              {category}
            </Typography>
            {questions.map((q) => (
              <Accordion
                key={q.id}
                expanded={expanded === q.id}
                onChange={handleChange(q.id)}
              >
                <AccordionSummary
                  expandIcon={<ExpandMoreIcon />}
                  aria-controls={`${q.id}-content`}
                  id={`${q.id}-header`}
                >
                  <Typography>{q.question}</Typography>
                </AccordionSummary>
                <AccordionDetails>
                  <Typography>{q.answer}</Typography>
                </AccordionDetails>
              </Accordion>
            ))}
          </Box>
        ))}
      </Paper>
    </PlannerLayout>
  );
};
